import React from "react";
import { Activity, PublicAmorgUser, rng, userHelper } from "../../../../amorg-common";
import { getUsers } from "../../../../api/userClientApi";
import { LoadingPageOverlay } from "../../../../designSystem/LoadingPageOverlay";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { ItemSelectorPanel } from "../../../../designSystem/compositeComponents/itemSelector/ItemSelectorPanel";
import clone from "clone";
import { updateActivityParticipants } from '../../../../api/activityClientApi';
import { Small } from "../../../../designSystem/typography/Body";

type ParticipantSelectorProps = {
    activity:Activity,
    onParticipantsUpdated:()=>void
}
export function ParticipantSelector(props:ParticipantSelectorProps):JSX.Element
{
    const [users, setUsers] = React.useState<PublicAmorgUser[]>([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const getData = async () => {
            setLoading(true);
            setUsers(await getUsers());
            setLoading(false);
        };
        getData();
    },[props.activity]);


    const items:{ 
        selectionValue:string, 
        title:string, 
        subtitle:string, 
        type:'user'|'participant', 
        selected:boolean 
    }[] = [];


    items.push(
        ...users.filter(u => 
            (u.permissionGroup.id === 'siteadmin' || u.permissionGroup.id === 'member')
            && !props.activity.participants.some(p => p.type.value === 'internal' && p.type.userId === u.id)
        )
        .map(u => (
            {
                selectionValue:u.id,
                title: userHelper.getPublicUserFullName(u),
                subtitle: u.permissionGroup.name,
                type: 'user' as ('user'|'participant'),
                selected:false
            }
        ))
    );
    
   items.push(
        ...props.activity.participants.map(p => {

            let role = p.role ? `${p.role} (EKSTERN)` : 'EKSTERN';
            if(p.type.value === 'internal')
            {
                const userId = p.type.userId;
                role = users.find(u => u.id === userId)?.permissionGroup.name || '';
            }

            return {
                selectionValue:p.id,
                title: p.name,
                subtitle: role,
                type: 'participant' as ('user'|'participant'),
                selected:true
            };
        })
    );
    items.sort((a,b) => a.title.localeCompare(b.title));

    return (
        <>
            <LoadingPageOverlay loading={loading} />
            <ItemSelectorPanel
                pageSize={10}
                items={items.map(i => ({
                    selectionValue:i.selectionValue,
                    selected:i.selected,
                    searchTexts:[i.title, i.subtitle],
                    renderComponent:
                            <Flex flexDirection="column">
                                <div>{i.title}</div>
                                <Small>{i.subtitle}</Small>
                            </Flex>
                }))}
                searchPlaceholder="Søg efter bruger"
                noItemsElement={<div>Ingen brugere fundet</div>}
                onSelectionChanged={async (selectionValue:string, checked:boolean) =>
                {
                    const updatedParticipants = clone(props.activity.participants);
                    if(checked)
                        updatedParticipants.push({ type:{value:'internal', userId:selectionValue}, id:rng.getRandomId(), name:'', role:'', email:'' });
                    else {
                        updatedParticipants.splice(updatedParticipants.findIndex(p => p.id === selectionValue), 1);
                    }
                    await updateActivityParticipants(props.activity.id, updatedParticipants);
                    props.onParticipantsUpdated();
                }} />
        </>
    );
}
